import { render, staticRenderFns } from "./RelatedContentList.vue?vue&type=template&id=31da1cd5&scoped=true"
import script from "./RelatedContentList.vue?vue&type=script&lang=js"
export * from "./RelatedContentList.vue?vue&type=script&lang=js"
import style0 from "./RelatedContentList.vue?vue&type=style&index=0&id=31da1cd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31da1cd5",
  null
  
)

export default component.exports